import React, { useContext, useEffect } from "react";
import { SetStateAction, useState } from "react";
import { useLocation } from "react-router-dom";
import { Paper, Snackbar, Stack, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { IAlimentoComposto, IGrupos_Homo_Eficiencia_Alimentar, IIntensidadeProdutiva, INecessidade_EA } from "../../../Interfaces/eficiencia_alimentar/plano_de_alimentacao";
import { del, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { CustomTextField, CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableHeadCellSemBorderfina } from "../../../Styles/tabelCellStyled/customTableCell";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { Alert } from "../../../Components/Alert/Alert";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { getCabecalhosEficiencia } from "../../../Componentes_modulo/getCabecalhosGrupoHomoEficiencia";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";



export interface ICabecalhoFormProps {
    obj_Cabecalho: IGrupos_Homo_Eficiencia_Alimentar | undefined;
    set_obj_Cabecalho: React.Dispatch<SetStateAction<IGrupos_Homo_Eficiencia_Alimentar | undefined>>;
    set_rows_necessidades: React.Dispatch<SetStateAction<INecessidade_EA[]>>;
    set_rows_alimento: React.Dispatch<SetStateAction<IAlimentoComposto[]>>;
    set_obj_intensidade: React.Dispatch<SetStateAction<IIntensidadeProdutiva| undefined>>;
    
}

export const CabecalhoGrupoHomoEficiencia: React.FC<ICabecalhoFormProps> = ({
    obj_Cabecalho,
    set_obj_Cabecalho,
    set_rows_necessidades,
    set_rows_alimento,
    set_obj_intensidade
}) => {
    const location = useLocation();
    const auth = useContext(AuthContext);

    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = React.useState("");
    const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
    const [openSnackError, setOpenSnackError] = React.useState(false);

    const [editingId, setEditingId] = useState<number | null>(null);
    const [createcabecalho, setCreateCabecalho] = useState(false);
    const [editCabecalho, setEditCabecalho] = useState(false);
    const [open_delete, set_open_delete] = useState(false);
    const [idToDelete, setIdToDelete] = useState<number | null | undefined>(0);

    const [cabecalhos, setCabecalhos] = useState<IGrupos_Homo_Eficiencia_Alimentar[]>([]);
    const [flag_editado, set_flag_editado] = React.useState(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);


    const handleCloseDialog = () => {

        handleCancel()

        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };

    useEffect(() => {
        (async () => {
            if (auth.lista_grupos_homo_eficiencia.length === 0) {
                const lista = await getCabecalhosEficiencia(location.state.id_identificacao, auth.token.cookie_token);

                auth.func_set_lista_grupos_homo_eficiencia(lista);
                setCabecalhos(lista)
            } else {
                setCabecalhos(auth.lista_grupos_homo_eficiencia);

            }
        })();
    }, []);

    const onInputChange = (event: any) => {
        const { name, value, } = event.target;
        set_flag_editado(true)

        set_obj_Cabecalho((prev: any) => ({
            ...prev,
            [name]: value,
        }));

    };

    const handleSaveNewCabecalho = async () => {
        if (
            obj_Cabecalho === undefined
        ) {
            setMessage("Preencha a tabela antes de gravar!");
            setOpenSnackError(true);
        } else {
            try {
                setIsLoading(true);

                let res = await post(auth.token.cookie_token, "/new_Grupos_Homogeneos", {
                    payload: {
                        id_grupo: 0,
                        grupo_descritivo: obj_Cabecalho?.grupo_descritivo === undefined ? "" : obj_Cabecalho.grupo_descritivo,
                        id_identificacao: location.state.id_identificacao,
                        last_update: new Date().toISOString(),
                        create_date: new Date().toISOString(),
                        uuid: "",
                    }
                });


                if (res.status === 200) {
                    const lista_aux = cabecalhos;
                    lista_aux.push(res.data.result[0]);

                    set_rows_necessidades((prevRows) => [...prevRows, res.data.result[1]])
                    set_rows_alimento((prevRows) => [...prevRows, res.data.result[2]])

                    setMessage("Gravado com sucesso!");
                    setOpenSnackSuccess(true);
                    setCreateCabecalho(false);
                    set_flag_editado(false)

                    // setCabecalhos((prevRows) => [...prevRows, (res.data.result)]);
                    setCabecalhos(lista_aux);
                    auth.func_set_lista_grupos_homo_eficiencia(lista_aux);


                    set_obj_Cabecalho(undefined);
                } else {
                    setMessage("Erro ao gravar!");
                    setOpenSnackError(true);
                }
                setIsLoading(false);
            } catch (error: any) {
                func_print("handleSaveNewCabecalho", error, true);
                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
                setIsLoading(false);
            }
        }
    };

    // EDITAR
    const handleEdit = (obj: IGrupos_Homo_Eficiencia_Alimentar) => {
        set_obj_Cabecalho(obj);
        setEditCabecalho(true);
        setCreateCabecalho(false)
    };

    const handleCancel = () => {
        setEditCabecalho(false);
        setEditingId(null);
        set_obj_Cabecalho(undefined);
        setCreateCabecalho(false)
    }



    const handleUpdateCabecalho = async () => {

        try {
            setIsLoading(true);
            let res = await post(auth.token.cookie_token, "update_Grupos_Homogeneos", {
                payload:
                {
                    id_grupo: obj_Cabecalho?.id_grupo,
                    grupo_descritivo: obj_Cabecalho?.grupo_descritivo === undefined ? "" : obj_Cabecalho.grupo_descritivo,
                    id_identificacao: location.state.id_identificacao,
                    last_update: obj_Cabecalho?.last_update,
                    create_date: obj_Cabecalho?.last_update,
                    uuid: obj_Cabecalho?.uuid,
                }
            });

            if (res.status === 200) {
                const updatedCabecalho =
                    cabecalhos.map((cab) => {
                        if (obj_Cabecalho?.id_grupo !== cab.id_grupo) {
                            return cab;
                        } else {
                            return (res.data.result)
                        }
                    }
                    );
                set_flag_editado(false)

                setEditCabecalho(false);
                setCabecalhos(updatedCabecalho);
                auth.func_set_lista_grupos_homo_eficiencia(updatedCabecalho);
                setMessage("Cabeçalho atualizado com sucesso!");
                setOpenSnackSuccess(true);
                set_obj_Cabecalho(undefined)
            } else {
                setMessage("Erro ao atualizar o cabeçalho!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("handleUpdateCabecalho", error, true);
            setMessage("Erro ao atualizar o cabeçalho!");
            setOpenSnackError(true);
            setIsLoading(false);
        }

    };

    // Delete
    const handleClickOpenDelete = (id: number | null | undefined) => {
        setIdToDelete(id);
        set_open_delete(true);
    };
    const handle_delete_cabecalho = async () => {
        try {
            setIsLoading(true);
            let res = await del(auth.token.cookie_token, `/delete_Grupos_Homogeneos/${idToDelete}`);

            if (res.status === 200) {
                setMessage("Registo eliminado com sucesso!");
                set_open_delete(false);

                let lista_aux: any = cabecalhos.filter((el) => {
                    if (el.id_grupo !== idToDelete) {
                        return el
                    }
                })
                setIdToDelete(null);
                set_rows_alimento(res.data.result[0])
                set_rows_necessidades(res.data.result[1])
                set_obj_intensidade(res.data.result[2])

                setCabecalhos(lista_aux === undefined ? [] : lista_aux);
                auth.func_set_lista_grupos_homo_eficiencia(lista_aux);

                setOpenSnackSuccess(true);
            } else {
                setMessage("Erro ao eliminar o registo!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("handleDelete", error, true);
            setMessage("Erro ao eliminar o registo!");
            setOpenSnackError(true);
            setIsLoading(false);
        }
    };

    return (
        <>
            {isLoading ?
                <LoadingVulpes />
                :
                <CustomThemeProvider>
                    <TableContainer
                        component={Paper}
                        variant="outlined"
                        sx={{
                            height: "auto",
                            width: "auto",
                            margin: 2,
                            padding: 2,
                        }}
                    >
                        <Snackbar
                            open={openSnackSuccess}
                            autoHideDuration={2000}
                            onClose={() => setOpenSnackSuccess(false)}
                        >
                            <Alert
                                onClose={() => setOpenSnackSuccess(false)}
                                severity="success"
                                sx={{ width: "100%" }}
                            >
                                {message}
                            </Alert>
                        </Snackbar>
                        <Snackbar
                            open={openSnackError}
                            autoHideDuration={2000}
                            onClose={() => setOpenSnackError(false)}
                        >
                            <Alert
                                onClose={() => setOpenSnackError(false)}
                                severity="error"
                                sx={{ width: "100%" }}
                            >
                                {message}
                            </Alert>
                        </Snackbar>
                        <table style={{ width: "100%" }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        colSpan={4}
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: 14,
                                            fontFamily: "candara",
                                        }}
                                    >
                                        2.3.Grupos Homogéneos (identificar atividade e raças)
                                    </TableCell>
                                </TableRow>
                                <TableRow>

                                    <StyledTableHeadCellSemBorderfina colSpan={4}  >
                                        <Stack direction="row" sx={{ justifyContent: "end" }}>
                                            <BarraDeFerramentas
                                                mostrarBotaoNovo
                                                textoBotaoNovo="Novo grupo homogéneo"
                                                aoClicarNovo={() =>{ setCreateCabecalho(true)

                                                    set_obj_Cabecalho(undefined)
                                                }}
                                            />
                                        </Stack>
                                    </StyledTableHeadCellSemBorderfina>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {createcabecalho === true ?
                                    <div style={{
                                        width: '100%',
                                        alignSelf: 'center',
                                        justifySelf: 'center',
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                        paddingTop: 10,
                                        paddingBottom: 10,
                                    }}>
                                        <div style={{
                                            display: "flex",
                                            flexDirection: 'row',
                                            flex: 0.33,
                                            justifyContent: 'center'
                                        }}>
                                            Grupo Homogéneo
                                        </div>
                                        <div style={{
                                            display: "flex",
                                            flexDirection: 'row',
                                            flex: 0.33
                                        }}>
                                            <CustomTextField
                                                name="grupo_descritivo"
                                                value={obj_Cabecalho?.grupo_descritivo}
                                                onChange={onInputChange}
                                            />
                                        </div>
                                        <div style={{
                                            display: "flex",
                                            flexDirection: 'row',
                                            flex: 0.33,
                                            justifyContent: 'center'
                                        }}>
                                            <ButtonCadernos
                                                mostrarBotaoGravar
                                                aoClicarGravar={() => handleSaveNewCabecalho()}
                                                mostrarBotaoCancelar
                                                aoClicarCancelar={() => {
                                                    if (flag_editado) {
                                                        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                    } else {
                                                        setCreateCabecalho(false)
                                                    }

                                                }}
                                            />
                                        </div>
                                    </div>
                                    :
                                    <></>
                                }

                                {cabecalhos.length <= 0 ?
                                    <></>
                                    :
                                    cabecalhos.map((grupo, key) => {
                                        return (
                                            <div key={key} >
                                                {editCabecalho === true && obj_Cabecalho?.id_grupo === grupo.id_grupo ?
                                                    <div style={{
                                                        width: '100%',
                                                        alignSelf: 'center',
                                                        justifySelf: 'center',
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "flex-start",
                                                        paddingTop: 10,
                                                        paddingBottom: 10,
                                                    }}>
                                                        <div style={{
                                                            display: "flex",
                                                            flexDirection: 'row',
                                                            flex: 0.33,
                                                            justifyContent: 'center'
                                                        }}>
                                                            Grupo Homogéneo {key + 1}
                                                        </div>
                                                        <div style={{
                                                            display: "flex",
                                                            flexDirection: 'row',
                                                            flex: 0.33
                                                        }}>
                                                            <CustomTextField
                                                                name="grupo_descritivo"
                                                                value={obj_Cabecalho?.grupo_descritivo}
                                                                onChange={onInputChange}
                                                            />
                                                        </div>
                                                        <div style={{
                                                            display: "flex",
                                                            flexDirection: 'row',
                                                            flex: 0.33,
                                                            justifyContent: 'center'
                                                        }}>
                                                            <ButtonCadernos
                                                                mostrarBotaoGravar
                                                                aoClicarGravar={() => handleUpdateCabecalho()}
                                                                mostrarBotaoCancelar
                                                                aoClicarCancelar={() => {
                                                                    if (flag_editado) {
                                                                        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                                    } else {
                                                                        handleCancel()
                                                                    }

                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    :
                                                    <div style={{
                                                        width: '100%',
                                                        alignSelf: 'center',
                                                        justifySelf: 'center',
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-evenly",
                                                        paddingTop: 10,
                                                        paddingBottom: 10,
                                                    }}>
                                                        <div style={{
                                                            fontWeight: 'bold',
                                                            fontSize: 14,
                                                            display: "flex",
                                                            flexDirection: 'row',
                                                            flex: 0.33,
                                                            justifyContent: 'center'
                                                        }}>
                                                            Grupo Homogéneo  {key + 1}
                                                        </div>
                                                        <div style={{
                                                            display: "flex",
                                                            flexDirection: 'row',
                                                            flex: 0.33
                                                        }}>{grupo.grupo_descritivo} </div>
                                                        <div style={{
                                                            display: "flex",
                                                            flexDirection: 'row',
                                                            flex: 0.33,
                                                            justifyContent: 'center'

                                                        }}>
                                                            <ButtonCadernos
                                                                mostrarBotaoEditar
                                                                aoClicarEditar={() => handleEdit(grupo)}
                                                                mostrarBotaoApagar
                                                                aoClicarApagar={() => handleClickOpenDelete(grupo.id_grupo)}
                                                            />
                                                        </div>
                                                    </div>
                                                }

                                            </div>
                                        )
                                    })}

                            </TableBody>


                        </table>
                    </TableContainer>
                </CustomThemeProvider >
            }
            <ConfirmDialog
                open={open_delete}
                onClose={() => set_open_delete(false)}
                onConfirm={handle_delete_cabecalho}
                message="Deseja eliminar o registo?"
            />
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
        </>
    );
}